import { render, staticRenderFns } from "./PayRangeUnsavedChanges.vue?vue&type=template&id=cb60c73c&scoped=true"
import script from "./PayRangeUnsavedChanges.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeUnsavedChanges.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeUnsavedChanges.vue?vue&type=style&index=0&id=cb60c73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb60c73c",
  null
  
)

export default component.exports